import store from '@/store'
import userGetters from '@/store/userModule/getterTypes'
import { env } from '@/lib/runtimeEnv'

declare global {
  interface Window {
    olark: ((method: string, options?: any) => any) | undefined
  }
}

export const hideOlark = (): void => {
  window.olark && window.olark('api.box.hide');
}

export const displayOlark = async (): Promise<void> => {
  await loadChatScript()

  const user = store.getters[userGetters.USER.NAMESPACED]
  if (!user) return

  const { firstName, lastName, email } = user
  const name = ((firstName || '') + ' ' + (lastName || '')).trim()
  email &&
    window.olark &&
    window.olark('api.visitor.updateEmailAddress', {
      emailAddress: email,
    })
  name &&
    window.olark &&
    window.olark('api.visitor.updateFullName', {
      fullName: name,
    })
}

const loadChatScript = async () => {
  embedScript()
  let tries = 0
  const retryLoad = setInterval(() => {
    if ((window as any).olark || tries > 10) {
      clearInterval(retryLoad)
      return (window as any).olark
    }
    tries++
  }, 500)
}

const embedScript = () => {
  if (document.querySelector('script#olarkScript')) {
    window.olark && window.olark('api.box.show');
    return
  }
  const olarkScript = document.createElement('script')
  olarkScript.setAttribute('id', 'olarkScript')
  olarkScript.setAttribute('async', 'true')
  olarkScript.setAttribute('type', 'text/javascript')
  olarkScript.innerHTML = `
    ;(function (o, l, a, r, k, y) {
      if (o.olark) return
      r = 'script'
      y = l.createElement(r)
      r = l.getElementsByTagName(r)[0]
      y.async = 1
      y.src = '//' + a
      r.parentNode.insertBefore(y, r)
      y = o.olark = function () {
        k.s.push(arguments)
        k.t.push(+new Date())
      }
      y.extend = function (i, j) {
        y('extend', i, j)
      }
      y.identify = function (i) {
        y('identify', (k.i = i))
      }
      y.configure = function (i, j) {
        y('configure', i, j)
        k.c[i] = j
      }
      k = y._ = { s: [], t: [+new Date()], c: {}, l: a }
    })(window, document, 'static.olark.com/jsclient/loader.js')

    olark.configure('box.start_hidden', true);
    olark.configure('system.is_single_page_application', true );
    olark.identify('${env.VITE_OLARK_ID}')
  `
  document.body.append(olarkScript)
}
